import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { t } from 'react-switch-lang';
import { checkSession, useRouter } from '../../../components/Router';
import Redirect from '../../../components/Redirect';
import MainLayout from '../../../components/MainLayout';
import usePartners from '../../../hooks/usePartners';
import { events, logAmpEvent } from '../../../utils/Amplitude';
import { setCurrentPartner } from '../../../redux/actions/PartnerActions';
import { getPartnerName } from '../../../utils/Helpers';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BackButton from '../../../components/BackButton';
import Reports from '../../../components/reports/Report';

function ReportsPage() {
  const router = useRouter();
  const queryParamPartnerSeq = router.query.partner;

  const [matchingPartner, setMatchingPartner] = useState(false);
  const [partners] = usePartners(true);
  const currentPartner = useSelector((state) => state.partner.currentPartner);
  const partnerName = getPartnerName(currentPartner);

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentPartner && matchingPartner) logAmpEvent(events.USER_VIEWED_REPORTS_PAGE, { 'Partner Seq': currentPartner?.Partner_Seq });
  }, [currentPartner, currentPartner?.Partner_Seq, matchingPartner]);

  useEffect(() => {
    // resolve query param partner and redux currentPartner if possible
    if (!partners) return;
    if (queryParamPartnerSeq) {
      const matchedPartner = partners.find((p) => p.Partner_Seq === queryParamPartnerSeq);
      if (matchedPartner) {
        setMatchingPartner(true);
        dispatch(setCurrentPartner(matchedPartner));
      }
    }
    if (partners.length === 1 && !matchingPartner) {
      const partner = partners[0];
      setMatchingPartner(true);
      dispatch(setCurrentPartner(partner));
      router.replaceStatic({
        pathname: router.pathname,
        query: { ...router.query, partner: partner.Partner_Seq },
      }, undefined, { shallow: true });
    }
    setLoading(false);
  }, [partners]); // eslint-disable-line

  if (loading) {
    return (
      <MainLayout title={t('PageTitle_Reports_Loading')}>
        <LoadingSpinner />
      </MainLayout>
    );
  }

  if (!matchingPartner) {
    return <Redirect path="/reports/select-partner" />;
  }

  // only if query param exists and has been resolved to a real partner
  return (
    <MainLayout title={t('PageTitle_Reports').replace('{Partner}', partnerName)}>
      <div className="widePageContainer">
        {partners.length > 1 ?
          <BackButton textKey="Reports_BackButtonTitle" path="/reports/select-partner" narrow /> :
          <BackButton textKey="SelectPartner_BackButtonTitle" path="/services" narrow />}
        <h1 className="reportPartnerNameTitle">
          {t('PageTitle_Reports').replace('{Partner}', partnerName)}
        </h1>
        <Reports />
      </div>
    </MainLayout>
  );
}

export default checkSession(ReportsPage, true);
export { getStaticPaths, getStaticProps } from '../../../utils/DynamicRoutes';
